import React from 'react';
import * as lib from '~/dependencies';
import * as NuacomComponents from '~/components';
import * as NuacomScreens from '~/screens';

export default function Routes() {
  return (
    <lib.Router>
      <lib.Switch>
        <NuacomComponents.PrivateRoutes
          path="/app"
          component={NuacomScreens.Home}
        />
        <lib.Route exact path="/auth" component={NuacomScreens.Auth} />
        <lib.Route
          path="/auth/recover-password"
          component={NuacomScreens.RecoverPassword}
        />
        <lib.Route
          path="/auth/reset-password"
          component={NuacomScreens.ResetPassword}
        />
        <lib.Route exact path="/" render={() => <lib.Redirect to="/app" />} />
        <lib.Route path="/logout" component={NuacomScreens.Logout} />
        <lib.Route path="/video" component={NuacomScreens.Video} />
      </lib.Switch>
    </lib.Router>
  );
}
